import Constants from 'expo-constants';

export const getEnv = (key: string) => {
  if (Constants.manifest?.extra) return Constants.manifest.extra[key];
  return '';
};
